import _ from 'lodash';

import { transport } from '../transport';
import { BASE_PATH, INVITATIONS_PATH } from './config';
import { WixMpResponse } from '../../types/http-responses';
import { Organization } from '../../types/entities';

function inviteOrganizationMember({ organizationId, member }) {
  const email = member.email;
  const securityGroups = _.uniq(member.securityGroups);

  return transport.post(`${BASE_PATH}/${organizationId}${INVITATIONS_PATH}`, {
    email,
    securityGroups,
  });
}

function acceptInviteOrganization({ organizationId }) {
  return transport.put(`${BASE_PATH}/${organizationId}${INVITATIONS_PATH}`);
}

function createOrganization({ name, projectName }) {
  return transport.post<WixMpResponse<Organization>>(BASE_PATH, {
    name,
    projectName,
  });
}

// TODO: talk with backend guys to extend this method (now only update for 'name' is available)
function updateOrganization({ organizationId, name }) {
  return transport.put<WixMpResponse<Organization>>(
    `${BASE_PATH}${organizationId}/name`,
    { name },
  );
}

function getOrganization({ organizationId }) {
  return transport.get<WixMpResponse<Organization>>(
    `${BASE_PATH}/${organizationId}`,
  );
}

export const organizationService = {
  inviteOrganizationMember,
  acceptInviteOrganization,

  createOrganization,
  updateOrganization,
  getOrganization,
};
